import React from "react";
import SignUp from "../SignUp/SignUp";
import "./SignUpModal.css";

const SignUpModal = ({ isOpen, onClose, onSuccess }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="signup-modal-overlay" onClick={handleBackdropClick}>
      <div className="signup-modal-wrapper">
        <div className="signup-modal-header">
          Sign up so we can save your cards and events
        </div>
        <div className="signup-modal-content">
          <button className="signup-modal-close" onClick={onClose}>
            ×
          </button>
          <SignUp onSuccess={onSuccess} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default SignUpModal;